import { render, staticRenderFns } from "./DepartamentoArgentina.vue?vue&type=template&id=f9b60f4c&lang=pug"
import script from "./DepartamentoArgentina.vue?vue&type=script&lang=js"
export * from "./DepartamentoArgentina.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports